import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0321 from "../../../lesson/course-03/lesson-21/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "5cb7c274-f3c3-467c-bee7-6a9f1b50f232",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0321),
    lesson: lesson0321,
  },
];

export default lessonLinks;
